import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getBlogs = async () => {
  const response = await axios.get(`${base_url}blog/`);

  return response.data;
};
const createBlog = async (blog) => {
  try {
    const response = await axios.post(`${base_url}blog/`, blog, {
      ...config,
      timeout: 120000,
    });
    return response.data;
  } catch (error) {
    console.error("Create blog API error:", error.response?.data || error.message);
    throw error;
  }
};
const updateBlog = async (blog) => {
  try {
    const response = await axios.put(
      `${base_url}blog/${blog.id}`,
      {
        title: blog.blogData.title,
        description: blog.blogData.description,
        category: blog.blogData.category,
        images: blog.blogData.images,
      },
      {
        ...config,
        timeout: 120000,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Update blog API error:", error.response?.data || error.message);
    throw error;
  }
};
const getBlog = async (id) => {
  const response = await axios.get(`${base_url}blog/${id}`, config);

  return response.data;
};

const deleteBlog = async (id) => {
  const response = await axios.delete(`${base_url}blog/${id}`, config);

  return response.data;
};
const blogService = {
  getBlogs,
  createBlog,
  getBlog,
  updateBlog,
  deleteBlog,
};

export default blogService;
